import { useTranslation } from 'react-i18next';
import { PendingDecision, SectionTitle } from '@/components/editorial';

/**
 * "How payments work" — TRF's payment rules, said once at the foot of the
 * Grants page (#2956). These are rules TRF already tells families by email
 * (Azalea gap report rows AZ-13, AZ-14, AZ-16, AZ-35): Signature is paid
 * monthly, bank changes happen in Bill.com, new statements and payment
 * changes reach TRF within 30 days, Travel and Family Fun pay on the 1st,
 * TRF does not cover late or other fees, and urgent requests go to the case
 * manager by email.
 *
 * Reference text, not a to-do, so it sits below every section that can ask
 * the family for something. The wording waits on TRF's approval; the `(?)`
 * says so.
 */
export function HowPaymentsWork() {
  const { t } = useTranslation('grants');
  // Literal keys, one per rule, so the extractor and the typed `t()` see each.
  const items = [
    t('page.howPayments.signature'),
    t('page.howPayments.bank'),
    t('page.howPayments.changes'),
    t('page.howPayments.firstOfMonth'),
    t('page.howPayments.fees'),
    t('page.howPayments.urgent'),
  ];
  return (
    <section className="space-y-2" aria-labelledby="how-payments-work-title" data-testid="how-payments-work">
      <div className="flex items-center gap-1.5">
        <SectionTitle as="h2" level="card-title" id="how-payments-work-title">
          {t('page.howPayments.title')}
        </SectionTitle>
        <PendingDecision id="grants-how-payments-work" side="right" />
      </div>
      <ul className="m-0 list-disc space-y-1 ps-5 text-body-sm text-stevens-ink-3">
        {items.map((line) => <li key={line}>{line}</li>)}
      </ul>
    </section>
  );
}
